import {_} from './i18n'

/**
 * @param {string} path
 * @param {() => string} getTitle
 * @returns {{path: string, title: string}}
 */
function createRoute(path, getTitle) {
  return {
    path: '/' + path,
    get title() {
      return getTitle()
    },
  }
}

const routes = {
  regions: createRoute('cities', () => _`Regiões`),
  cities: createRoute('cities', () => _`Cidades`),
  states: createRoute('states', () => _`Estados`),
  companies: createRoute('companies', () => _`Empresas`),
  proposals: createRoute('proposals', () => _`Oportunidades`),
}

export const matchRoute = (route) => {
  const curPath = window.location.pathname
  return curPath.includes(route.path)
}
export const matchRouteExact = (route) => {
  const curPath = window.location.pathname
  return curPath === route.path
}

export default routes
